<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="analyze-page" v-else-if="loaded" > 
        
            
        
        <div class="row no-gutters mb-3 mt-3" v-if="contentType == 'full'" >
            
            <div class="col-12 col-md-6" >
                <span class="h3 font-900" style="line-height: 34px; margin-rigth: 15px" > Select dates:  </span>

                <date-picker v-model="period" range valueType="format" :format="formatDate" confirm class="datepicker ml-2" @change="refresh_chart" clear-button-icon="false" :shortcuts="shortcuts" ></date-picker>
                
            </div>
            
            <div class="col-12 col-md-3 text-md-right mt-2 mt-md-0" style="line-height: 34px;"  >
                                
            </div>
            
            <div class="col-12 col-md-3 text-md-right" style=""  >
                
                Refresh: <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>
                
            </div>
            
        </div>
        
        <div class="row pl-3 pr-3 flex-wrap-scroll d-none" >
            
            <div class="col-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2" v-if="mrr.length == 0" > - </h1>
                    <h1 class="h2" v-else-if="mrr.length > 0" > 
                        {{ Numberformatter(  ( mrr.map(o => o.count).reduce((a, c) => { return parseFloat(a) + parseFloat(c) }) ), 'number' ) }} 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Anual Run Rate </p>
                </div>
            </div>
            
            <div class="col-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2" v-if="activeCustomers.length == 0" > - </h1>
                    <h1 class="h2" v-else-if="activeCustomers.length > 0" > 
                        {{ activeCustomers[ activeCustomers.length - 1 ].count }} 
                        <span v-if="activeCustomers.length > 1" class="font-size-12" v-html="Numberformatter( ( ( activeCustomers[ activeCustomers.length - 1 ].count - activeCustomers[ activeCustomers.length - 2 ].count )*100 / activeCustomers[ activeCustomers.length - 1 ].count ), 'percentage', true )" ></span> 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Last month active customers </p>
                </div>
            </div>
            
            <div class="col-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2" v-if="revenue.length == 0" > - </h1>
                    <h1 class="h2" v-else-if="revenue.length > 0" > 
                        {{ Numberformatter( revenue[ revenue.length - 1 ].count, 'number' ) }} 
                        <span v-if="revenue.length > 1" class="font-size-12" v-html="Numberformatter( ( ( revenue[ revenue.length - 1 ].count - revenue[ revenue.length - 2 ].count )*100 / revenue[ revenue.length - 1 ].count ), 'percentage', true )" ></span> 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Last month revenue </p>
                </div>
            </div>
            
            <div class="col-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2" v-if="churnRate.length == 0" > - </h1>
                    <h1 class="h2" v-else-if="churnRate.length > 0" > 
                        {{  churnRate[ churnRate.length - 1 ].count }} 
                        <span v-if="churnRate.length > 1" class="font-size-12" v-html="Numberformatter( ( ( churnRate[ churnRate.length - 1 ].count - churnRate[ churnRate.length - 2 ].count )*100 / churnRate[ churnRate.length - 1 ].count ), 'percentage', true, 'inverted' )" ></span> 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Last month churn </p>
                </div>
            </div>
            
            <div class="col-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2" v-if="ltv.length == 0" > - </h1>
                    <h1 class="h2" v-else-if="ltv.length > 0" > 
                        {{  ltv[ ltv.length - 1 ].count }} 
                        <span v-if="ltv.length > 1" class="font-size-12" v-html="Numberformatter( ( ( ltv[ ltv.length - 1 ].count - ltv[ ltv.length - 2 ].count )*100 / ltv[ ltv.length - 1 ].count ), 'percentage', true )" ></span> 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Last month's LTV </p>
                </div>
            </div>
            
            <div class="col-auto p-1 d-none" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2" v-if="revenueChurn.length == 0" > - </h1>
                    <h1 class="h2" v-else-if="revenueChurn.length > 0" > 
                        {{ revenueChurn[ revenueChurn.length - 1 ].count.toFixed(2) }} 
                        <span v-if="revenueChurn.length > 1" class="font-size-12" v-html="Numberformatter( ( ( revenueChurn[ revenueChurn.length - 1 ].count - revenueChurn[ revenueChurn.length - 2 ].count )*100 / revenueChurn[ revenueChurn.length - 1 ].count ), 'percentage', true, 'inverted' )" ></span> 
                    </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Last month revenue churn </p>
                </div>
            </div>
            
        </div>
        
        <div class="row no-gutters mt-2" >
            <div class="col-12 mt-2 mb-2" >
                
                <div class="row atlass-grid no-gutters" >
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="activeCustomers" CHART="standard" TITLE="Active customers" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="purchases" CHART="standard" TITLE="Successful Purchases" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="revenue" CHART="standard" TITLE="Revenue" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" symbol="$" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="growth_rate" CHART="standard" TITLE="Growth Rate" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="mrr" CHART="standard-total-last" TITLE="MRR" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" symbol="$" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="avg_revenue_per_customer" CHART="standard-total-last" TITLE="ARPU" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" symbol="$" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="avg_purchase_value" CHART="standard-total-last" TITLE="AOV" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" symbol="$" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="churnRate" CHART="standard-total-last" TITLE="Churn" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock :data="ltv" CHART="standard-total-last" TITLE="LTV" :startDate="startDate" :endDate="endDate" v-else-if="chartLoaded" :HEIGHT="235" CHART_COMPONENT="full" symbol="$" :chartOptions="smallChartOptions"  > </chartBlock>
                    </div>
                    <!--
                    <div class="col-12 col-md-6 col-lg-4 p-2 p-md-4" >
                        <spinner v-if="!chartLoaded" ></spinner>
                        <chartBlock_bar v-else-if="chartLoaded && customers.length > 0" :data="customers" CHART="standard-total-last"  TITLE="CUSTOMERS" :startDate="startDate" :endDate="endDate" :HEIGHT="235" CHART_COMPONENT="full" symbol="$" :chartOptions="smallChartOptions"  > </chartBlock_bar>
                    </div>
                    -->
                    
                </div>
                
            </div>
        </div>
        
        <modal :modalData="modalData" :modalState="modalState" modalComponent="engagement" ></modal>
        
    </div><!-- end content template-padding -->

</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
    
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
    
import analyzeToday from '@/components/analyzeToday.vue'    
import lineChart from '@/components/charts/lineChart_full.js'   
import barChart from '@/components/charts/barChart_full.js'   
import chartBlock from '@/components/chartBlock.vue'    
import chartBlock_bar from '@/components/chartBlock-bar.vue'    
import modal from '@/components/modal.vue'    

    
import helper from '@/helpers/helpers.js';
    
export default{
    name: "organizations",
    components:{
        lineChart,
        barChart,
        chartBlock,
        analyzeToday,
        modal,
        chartBlock_bar
    },
    props:{
        contentType: { type: [ String ], default: 'full' }, /* full -> full page; overview -> overview source */ 
        parentPeriod: { type: [ Array ], default: null }, 
        passedAPPKEY:{ type : [String, Boolean], default: false },
    },
    data () {
        return {
            loaded: false,
            filter: '',
            rows: [],
            
            dataLoaded: false,
            modalData: null,
            modalState: false,
            
            startDate: null,
            endDate: null,
            formatDate: 'D MMM YYYY',
            period: [ "", "" ],
            shortcuts: [
                { 
                    text: 'Today', 
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('day').toDate();
                        let end = this.$moment(Date.now()).endOf('day').toDate();

                        let period = [ start, end ];
                        //console.log(period)
                        return period;
                    } 
                },
                {
                    text: 'Yesterday',
                    onClick: () => {
                        //console.log( Date.now() )
                        //let start = this.$moment( ).subtract(1,'d').format( "YYYY-MM-DD 00:00:00" )
                        //let end = this.$moment( ).subtract(1,'d').endOf('day').format( "YYYY-MM-DD 00:00:00" )
                        
                        let start = this.$moment( ).subtract(1,'d').toDate();
                        let end = this.$moment( ).subtract(1,'d').endOf('day').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 7 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(7,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'weeks').startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'weeks').endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('month').toDate();
                        let end = this.$moment(Date.now()).endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 30 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(30,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'months').startOf('month').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'months').endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 3 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(3,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 6 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(6,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
            ],
            
            chartLoaded: false,
            
            
            CHART_COLUMNS: [],
            CHART_SERIES: [],
            CHART_SERIES_COMPARE: [],

            smallChartOptions:{
                maxTicksLimit: 12,
                yAxesgridLines: true,
                xAxesgridLines: true
            },
            
            customers: [],
            activeCustomers: [],
            purchases: [],
            churnRate: [],
            revenue: [],
            revenueChurn: [],
            avg_revenue_per_customer: [],
            avg_purchase_value: [],
            avg_purchase_freq_rate: [],
            customer_value: [],
            mrr: [],
            growth_rate: [],
            customer_growth_rate: [],
            ltv: []
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        this.loaded = true
        this.init_period(  )
        
    },
    computed: {
    },
    methods: {
        init_period(){
            
            let start = this.$moment(Date.now()).subtract(12,'month').startOf('month').format('D MMM YYYY');
            let end = this.$moment(Date.now()).subtract(1,'month').endOf('month').format('D MMM YYYY');
            //let end = this.$moment(Date.now()).endOf('month').format('D MMM YYYY');

            if( this.parentPeriod != null ){
                start = this.parentPeriod[0]
                end = this.parentPeriod[1]
            }
            
            this.period = [ start, end ];
            
            this.get_data()
            this.get_customer_stats()
            //refreshData()
            
        },

        get_data( ){
            
            this.chartLoaded = false
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()   
            let offset = moment.tz(this.period[0], timezone ).format('Z')
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            
            let groupBy = 'month'
            if( ( end - start ) < ( 60*60*24*60 ) ){
                groupBy = 'day'
            }

            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                //url: process.env.ROOT_API+'/analyze/stats/all-stats', 
                url: 'https://sql.theatlass.com/api-v2/analyze/stats.php?query=all', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment(this.period[0]).unix(),
                    //"endDate":  moment(this.period[1]).endOf('day').unix(),
                    "startDate":  start,
                    "endDate":  end,
                    "groupBy": groupBy,
                    "timezone_offset": offset
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let data = resp.data.data
                    
                    let activeCustomers = []
                    let purchases = []
                    let revenue = []
                    
                    let churnRate = []
                    let ltv = []
                    let revenueChurnRate = []
                    
                    let avg_revenue_per_customer = []
                    let avg_purchase_value = []
                    let avg_purchase_freq_rate = []
                    let customer_value = []
                    
                    let mrr = []
                    let growth_rate = []
                    let customer_growth_rate = []
                    
                    /*
                        date: '2022-01',
                        purchases: 241,
                        customers: 224,
                        revenue: 96048.65,
                        customers_start: 241,
                        customers_end: 224,
                        avg_revenue_per_customer: 428.7886160714285,
                        avg_purchase_value: 398.5421161825726,
                        avg_purchase_freq_rate: 1.0758928571428572,
                        growth_rate: -0.16071542479056922,
                        customer_growth_rate: -0.07053941908713693,
                        churn: 0.07053941908713693,
                        revenueChurn: 0.16071542479056922,
                        mrr: 96048.65
                    */
                    
                    data.forEach((row, i)=>{
                        //console.log(row)
                        //TEST for screenshots
                        /*
                        if( i == 0 ){
                            row.churn = 0.04
                        }
                        if( i == 1 ){
                            row.churn = 0.06
                        }
                        
                        if( i == 2 ){
                            row.LTV = 837.566
                            row.avg_purchase_value = 165.23
                            row.churn = 0.05
                        }
                        if( i == 3 ){
                            row.churn = 0.055
                        }
                        if( i == 4 ){
                            row.churn = 0.06
                        }
                        
                        //if( row.date == '2021-09' ){ // 5
                        if( i == 5 ){ // 5
                            row.churn = 0.05
                        }
                        //console.log(row)
                        //if( row.date == '2021-10' ){
                        if( i == 6 ){
                            row.LTV = 2138.566
                            row.avg_purchase_value = 495.23
                            row.customers = 274
                            row.revenue = 143075.82
                            row.churn = 0.04
                        }
                        if( row.date == '2021-11' ){
                            row.customers = 221
                            row.avg_revenue_per_customer = 551
                            row.churn = 0.05
                        }
                        if( row.date == '2021-12' ){
                            row.avg_revenue_per_customer = 752
                            row.churn = 0.03
                        }

                        if( row.date == '2022-01' ){
                            row.avg_revenue_per_customer = 592
                            row.churn = 0.04
                        }

                        if( row.date == '2022-02' ){
                            row.LTV = 1810.34
                            row.avg_purchase_value = 381.52
                            row.customers = 248
                            row.avg_revenue_per_customer = 664
                            row.churn = 0.03
                        }
                        
                        if( row.date == '2022-03' ){
                            row.LTV = 1952.97
                            row.avg_purchase_value = 465.91
                            row.customers = 259
                            row.avg_revenue_per_customer = 813.91
                            row.churn = 0.025
                        }
                        */
                        //TEST for screenshots
                        
                        let datetime = this.$moment(row.date, 'YYYY-MM','UTC').unix()
                        row.datetime = datetime
                        
                        //add to activeCustomers array
                        activeCustomers.push( { date: row.date, count: row.customers } )
                        purchases.push( { date: row.date, count: row.purchases } )
                        revenue.push( { date: row.date, count: row.revenue } )
                    
                        
                        let avg_revenue_per_customer_amount = 0
                        if( row.avg_revenue_per_customer ){
                            avg_revenue_per_customer_amount = row.avg_revenue_per_customer.toFixed(2) 
                        }
                        let avg_purchase_value_amount = 0
                        if( row.avg_purchase_value ){
                            avg_purchase_value_amount = row.avg_purchase_value.toFixed(2) 
                        }
                        let avg_purchase_freq_rate_amount = 0
                        if( row.avg_purchase_freq_rate ){
                            avg_purchase_freq_rate_amount = row.avg_purchase_freq_rate.toFixed(2) 
                        }
                        let customer_value_amount = 0
                        if( row.customer_value ){
                            customer_value_amount = row.customer_value.toFixed(2) 
                        }
                        let LTV_amount = 0
                        if( row.LTV ){
                            LTV_amount = row.LTV.toFixed(2) 
                        }
                        let mrr_amount = 0
                        if( row.recurring_revenue ){
                            mrr_amount = parseFloat( row.recurring_revenue ).toFixed(2) 
                        }
                        let growth_rate_amount = 0
                        if( row.growth_rate ){
                            growth_rate_amount = row.growth_rate.toFixed(2) 
                        }
                        let customer_growth_rate_amount = 0
                        if( row.customer_growth_rate ){
                            customer_growth_rate_amount = row.customer_growth_rate.toFixed(2) 
                        }
                        let churn_amount = 0
                        if( row.churn ){
                            churn_amount = row.churn.toFixed(2) 
                        }
                        let revenueChurn = 0
                        if( row.revenueChurn ){
                            revenueChurn = row.revenueChurn.toFixed(2) 
                        }
                        
                        //AVERAGE REVENUE PER CUSTOMER
                        avg_revenue_per_customer.push( { date: row.date, count: avg_revenue_per_customer_amount } )
                        //AVERAGE PURCHASE VALUE
                        avg_purchase_value.push( { date: row.date, count: avg_purchase_value_amount } )
                        //AVERAGE PURCHASE FREQ RATE
                        avg_purchase_freq_rate.push( { date: row.date, count: avg_purchase_freq_rate_amount } )
                        //CUSTOMER VALUE
                        customer_value.push( { date: row.date, count: customer_value_amount } )
                        ltv.push( { date: row.date, count: LTV_amount } )
                        
                        //MRR
                        mrr.push( { date: row.date, count: mrr_amount } )
                        //GROWTH RATE
                        growth_rate.push( { date: row.date, count: growth_rate_amount } )
                        customer_growth_rate.push( { date: row.date, count: customer_growth_rate } )
                        
                        //add to churn array
                        churnRate.push( { date: row.date, count: churn_amount } )
                        //add to churn revenue array
                        revenueChurnRate.push( { date: row.date, count: revenueChurn } )
                        
                    })
                    
                    this.activeCustomers = activeCustomers
                    this.purchases = purchases
                    this.revenue = revenue
                    
                    this.ltv = ltv
                    this.churnRate = churnRate
                    this.revenueChurn = revenueChurnRate
                    
                    this.avg_revenue_per_customer = avg_revenue_per_customer
                    this.avg_purchase_value = avg_purchase_value
                    this.avg_purchase_freq_rate = avg_purchase_freq_rate
                    this.customer_value = customer_value
                    
                    this.mrr = mrr
                    
                    this.growth_rate = growth_rate
                    this.customer_growth_rate = customer_growth_rate
                    
                }
                
            })
            .then(function(sales){
                
                //console.log( this.CHART_COLUMNS )
                //console.log( this.CHART_SERIES )
                this.chartLoaded = true
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error calculating LTV. Please reach out to us!'
                })
                
            }); //end axios 
            
        },

        get_customer_stats( ){
            
            //NOT USED
            return false
            //NOT USED
            
            this.chartLoaded = false
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()   
            let offset = moment.tz(this.period[0], timezone ).format('Z')
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            
            let groupBy = 'month'
            if( ( end - start ) < ( 60*60*24*60 ) ){
                groupBy = 'day'
            }

            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                //url: process.env.ROOT_API+'/analyze/stats/all-stats', 
                url: 'https://sql.theatlass.com/api-v2/analyze/stats.php?query=active-customers-stats', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment(this.period[0]).unix(),
                    //"endDate":  moment(this.period[1]).endOf('day').unix(),
                    "startDate":  start,
                    "endDate":  end,
                    "groupBy": groupBy,
                    "timezone_offset": offset
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let data = resp.data.data
                    console.log(data)
                    let customers = []
                    let all_cusotmers = []
                    let new_cusotmers = []
                    let canceled = []
                    let reactivated = []
                    
                    
                    let customer_columns = []
                    data.forEach((row, i)=>{
                        //add to activeCustomers array
                        all_cusotmers.push( { date: row.date, count: row.stats.active - row.stats.customers[0].count - row.stats.customers[1].count - row.stats.customers[2].count  } )
                        new_cusotmers.push( { date: row.date, count: row.stats.customers[0].count } )
                        canceled.push( { date: row.date, count: row.stats.customers[1].count } )
                        reactivated.push( { date: row.date, count: row.stats.customers[2].count } )
                        
                        let datetime = this.$moment(row.date, 'YYYY-MM','UTC').unix()
                        row.datetime = datetime
                        
                    })
                    
                    customers.push( { name: "existing customers", data: all_cusotmers } )
                    customers.push( { name: "new customers", data: new_cusotmers } )
                    customers.push( { name: "canceled customers", data: canceled } )
                    customers.push( { name: "reactivated customers", data: reactivated } )
                
                    this.customers = customers
                    
                }
                
            })
            .then(function(sales){
                
                //console.log( this.CHART_COLUMNS )
                //console.log( this.CHART_SERIES )
                this.chartLoaded = true
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error calculating LTV. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        refresh_chart( target ){
            
            //console.log(target)
            this.CHART_COLUMNS = []
            this.CHART_SERIES = []
            this.get_data( )
            this.get_customer_stats()
            
        },
        
        fModalOpen( data ){
            this.modalData = data
            this.modalState = true
        },
        
        Numberformatter(value, type, html, color ) {   
            return helper.Numberformatter(value, type, html, color );
        }
        
    },
    watch:{
        parentPeriod(){
            this.init_period()
        }
    },
    computed:{

        
    },
}
</script>


<style lang="scss" >
    
     @import '@/assets/css/variables.scss';
    
    .w-45{
        width: 48%;
    }
    
    .w-45 > .input-group-text,
    .w-4 > .input-group-text
    {
        width: 100%;
    }
    
    .w-4{
        width: 4%;
    }

    .col-55{
        width: 45.8%;
    }
    
</style>


// WEBPACK FOOTER //
// src/templates/analyze/Acquisition.vue